import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { searchSymbols, syncSymbols } from '../../services/SymbolsService';
import { PrivatePageLayout, PageHeader, PageTableCard } from '../../components/PrivatePage';
import { AppButton } from '../../components/AppButton/AppButton';
import SymbolModal from './SymbolModal';
import SymbolRow from './SymbolRow';
import Pagination from '../../components/Pagination/Pagination';
import Toast from '../../components/Toast/Toast';
import SearchSymbol from './SearchSymbol';

function Symbols() {
    const history = useHistory();
    const defaultLocation = useLocation();

    function getPage(location) {
        if (!location) location = defaultLocation;
        return new URLSearchParams(location.search).get('page') || '1';
    }

    useEffect(() => {
        return history.listen((location) => {
            setPage(getPage(location));
        });
    }, [history]);

    const [symbols, setSymbols] = useState([]);
    const [count, setCount] = useState(0);
    const [page, setPage] = useState(getPage());
    const [notification, setNotification] = useState({});
    const [isSyncing, setIsSyncing] = useState(false);
    const [viewSymbol, setViewSymbol] = useState({});
    const [search, setSearch] = useState('');

    function errorHandling(err) {
        console.error(err.response ? err.response.data : err.message);
        setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
    }

    useEffect(() => {
        searchSymbols(search, getPage())
            .then((result) => {
                setSymbols(result.rows);
                setCount(result.count);
            })
            .catch((err) => errorHandling(err));
    }, [isSyncing, search, page]);

    function onSyncClick() {
        setIsSyncing(true);
        syncSymbols()
            .then(() => {
                setNotification({ type: 'success', text: 'Synced successfully!' });
                setIsSyncing(false);
            })
            .catch((err) => {
                errorHandling(err);
                setIsSyncing(false);
            });
    }

    function onViewClick(event) {
        const coinpair = event.target.id.replace('view', '');
        const symbol = symbols.find((s) => s.symbol === coinpair);
        setViewSymbol(symbol);
    }

    function onSearchChange(event) {
        setSearch(event.target.value);
    }

    return (
        <PrivatePageLayout width="full">
            <PageHeader
                eyebrow="Admin"
                title="Symbols"
                subtitle="Exchange pairs, precision, and minimum order sizes."
                actions={(
                    <div className="private-page-header-filters">
                        <AppButton variant="primary" size="md" onClick={onSyncClick}>
                            {isSyncing ? 'Syncing…' : 'Sync'}
                        </AppButton>
                        <SearchSymbol placeholder={search} onChange={onSearchChange} />
                    </div>
                )}
            />
            <PageTableCard>
                <div className="table-wrapper table-responsive">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th>Symbol</th>
                                <th>Base prec</th>
                                <th>Quote prec</th>
                                <th>Min notional</th>
                                <th>Min lot size</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {symbols.map((item) => (
                                <SymbolRow key={item.symbol} data={item} onClick={onViewClick} />
                            ))}
                        </tbody>
                    </table>
                </div>
                <Pagination count={count} max={15} size={20} />
            </PageTableCard>
            <Toast text={notification.text} type={notification.type} />
            <SymbolModal data={viewSymbol} />
        </PrivatePageLayout>
    );
}

export default Symbols;